import { createFileRoute } from '@tanstack/react-router';
import { JourneysReportingWebhooksHandoff } from '@/pages/workspaces/integrations/reporting-webhooks/routing';

function JourneysEditReportingWebhookRoute() {
  const { webhookId } = Route.useParams();

  return <JourneysReportingWebhooksHandoff kind="edit" webhookId={webhookId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/reporting-webhooks/$webhookId',
)({
  component: JourneysEditReportingWebhookRoute,
});
